import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../App.css'
import './style.css'
import {
  Grid, TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog
} from '@material-ui/core';
import isEmpty from 'lodash.isempty';
import NumberFormat from 'react-number-format';
import _ from 'lodash'
import numeral from 'numeral';
import 'numeral/locales/de'
import { AddYear, UpdateCapacityPlannings, CompareCapacityWithPlan } from './ProjectsAction';
numeral.locale('de');

const formatter = new Intl.NumberFormat('de-DE', {
  currency: 'EUR',
})

class CapacityPlanning extends Component {

  constructor(props) {
    super(props)
    this.state = {
      propsProjectData: this.props.project_data,
      projectData: [],
      projectId: '',
      yearData: '',
      newYear: '',
      addYearError: false,
      totalYearSum: [],
      totalSummePlan: 0,
      totalvertragel: 0,
      totalDifferenz: 0,
      totalRechnungen: 0,
      targetedYearSum: 0,
      changes: false,
      saveChangesDialog: false,
      comparedValText: '',
      color: 'red'
    }

  }


  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { propsProjectData } = this.state
    if (nextProps.project_data !== propsProjectData) {
      this.setState({ propsProjectData: nextProps.project_data, projectData: [] }, () => this.componentDidMount())
      this.props.isBlockingCheckfalse()

    }
  }

  updateCapacityPlannings = () => {
    const dataObj = this.state;
    const { UpdateCapacityPlannings } = this.props
    UpdateCapacityPlannings(dataObj)
  }
  componentDidMount = () => {
    let { projectData, propsProjectData } = this.state;
    this.props.CompareCapacityWithPlan(propsProjectData.id)
    let groupByKey = _.chain(propsProjectData.project_years)
      .groupBy("consultant_function")
      .map((value, key) => ({ name: key, data: value }))
      .value()
    let newData = groupByKey[0].data.map(item => {
      return item
    })
    let yearSumArray = []
    newData.map((item, index) => {
      let forProjectData = {
        functionId: item[0].consultant_function_id,
        name: item[0].consultant_function,
        yearDaySum: Number(item[0].years_day_sum),
        vertragl: Number(item[0].vertragl),
        differenz: Number(item[0].differenz),
        rechnungen: Number(item[0].rechnungen)
      }
      let arrayForData = []
      item.map(data => {
        let yearIndex = yearSumArray.findIndex(e => e.year === data.year)
        if (yearIndex === -1) {
          yearSumArray.push({
            year: data.year,
            daysum: Number(data.days)
          })
        } else {
          if (data.days !== null)
            yearSumArray[yearIndex].daysum += Number(data.days)
        }
        arrayForData.push({
          rowId: data.id,
          year: data.year,
          days: Number(data.days),
        })
      })
      forProjectData["newRow"] = arrayForData
      projectData.push(forProjectData)
    })
    let vertSum = 0
    let diffSum = 0
    let yeardaySum = 0
    let rechnungenSum = 0
    projectData.map(item => {
      vertSum += Number(item.vertragl)
      diffSum += Number(item.differenz)
      yeardaySum += Number(item.yearDaySum.toFixed(2))
      rechnungenSum += Number(item.rechnungen)
    })
    this.setState({
      totalSummePlan: yeardaySum.toFixed(2),
      totalvertragel: vertSum.toFixed(2),
      totalDifferenz: diffSum.toFixed(2),
      totalRechnungen: rechnungenSum.toFixed(2),
      totalYearSum: yearSumArray,
      projectData,
      projectId: propsProjectData.id,
    })

  }

  renderTableHeader = () => {
    const { year_list } = this.props
    if (!isEmpty(year_list)) {
      return year_list.map((key, index) => {
        return <TableCell align='right' key={index} width="45%">{key}</TableCell>
      })
    }
  }

  tableFields = (data, isInactive) => {
    if (!isEmpty(data)) {
      return data.newRow.map((row, index) => {
        return (
          <TableCell key={index} align="center">
            <NumberFormat
              customInput={TextField}
              className="rightToLeft"
              inputProps={{
                maxLength: 40
              }}
              variant="outlined"
              value={row.days !== null ? row.days : 0}
              thousandSeparator='.'
              decimalSeparator=","
              fixedDecimalScale={true}
              decimalScale='2'
              disabled={isInactive}
              onChange={(e) => this.handleChangeField(e, data, index)}
            />
          </TableCell>
        )
      })
    }
  }

  handleChangeField = (e, data, index) => {
    const { projectData, totalYearSum } = this.state
    const { compare_list } = this.props
    let vertSum = 0
    let diffSum = 0
    let yeardaySum = 0
    let rechnungenSum = 0
    let yerColSum = []
    let comparedText = ''
    let colour = ""
    projectData.map((item, rowIndex) => {

      if (item.newRow[index].rowId === data.newRow[index].rowId) {
        let compareKey = item.functionId + '_' + data.newRow[index].year
        let tobeCompared = compare_list[compareKey]
        if (tobeCompared !== undefined) {
          if (Number(tobeCompared) >= numeral(e.target.value).value()) {
            comparedText = `geplante Tage für die Funktion ${item.name} in ${data.newRow[index].year}: ${formatter.format(tobeCompared)}  Tage / Kapazitätsplanung: ${e.target.value === "" ? 0 : formatter.format(numeral(e.target.value).value())}  Tage`
            colour = "red"
          } else {
            comparedText = `geplante Tage für die Funktion ${item.name} in ${data.newRow[index].year}: ${formatter.format(tobeCompared)}  Tage / Kapazitätsplanung: ${e.target.value === "" ? 0 : formatter.format(numeral(e.target.value).value())}  Tage`
            colour = "green"
          }
        } else {
          comparedText = `geplante Tage für die Funktion ${item.name} in ${data.newRow[index].year}: 0  Tage / Kapazitätsplanung: ${e.target.value === "" ? 0 : formatter.format(numeral(e.target.value).value())}  Tage`
          colour = "green"
        }
        let sum = 0
        item.newRow[index].days = numeral(e.target.value).value()
        item.newRow.forEach(element => {
          sum += Number(element.days)
        })
        item.differenz = Number((Number(item.vertragl) - Number(sum)).toFixed(2))
        item.yearDaySum = parseFloat(sum.toFixed(2))
      }
      if (yerColSum[rowIndex]) {
        yerColSum[rowIndex] += Number(item.newRow[index].days)
      } else {
        yerColSum[rowIndex] = Number(item.newRow[index].days)
      }
      vertSum += Number(item.vertragl)
      diffSum += Number(item.differenz)
      yeardaySum += Number(item.yearDaySum)
      rechnungenSum += Number(item.rechnungen)
    })
    let colSum = yerColSum.reduce((a, b) => a + b)
    let yearCol = totalYearSum
    yearCol[index].daysum = parseFloat(colSum.toFixed(2))
    this.setState({
      targetedYearSum: numeral(e.target.value).value(),
      totalSummePlan: yeardaySum.toFixed(2),
      totalvertragel: vertSum.toFixed(2),
      totalDifferenz: diffSum.toFixed(2),
      totalRechnungen: rechnungenSum.toFixed(2),
      totalYearSum: yearCol,
      comparedValText: comparedText,
      color: colour,
      projectData,
      changes: true
    }, () => this.props.isBlockingCheck())
  }


  render() {
    const { projectId, newYear, changes, saveChangesDialog, projectData, totalYearSum, totalSummePlan, totalvertragel, totalRechnungen, totalDifferenz } = this.state
    const dataObj = this.state
    const { AddYear, UpdateCapacityPlannings, forOther, forOwn, isInactive } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    return (
      <div className={`${(Number(access_rights.projects_capacity_for_other) !== 2 && forOther) || (Number(access_rights.projects_capacity_for_own) !== 2 && !forOwn && !forOther) || (Number(access_rights.projects_capacity_for_own) !== 2 && forOwn) ?
        "disableALlFields" : ""}`}>
        {!((Number(access_rights.projects_capacity_for_other) !== 2 && forOther) || (Number(access_rights.projects_capacity_for_own) !== 2 && forOwn)) &&
          <div style={{ textAlign: 'right' }}>
            <Button variant="outlined" color="primary" className="m-10" onClick={this.updateCapacityPlannings} >Speichern</Button>
          </div>
        }
        <div className="capacityTable capicityInput tabsTableStyle">
          <Grid container spacing={1}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell width="45%">Beraterfunktion</TableCell>
                    {this.renderTableHeader()}
                    <TableCell width="45%" align='right'>Summe Plan</TableCell>
                    <TableCell width="45%" align='right'>vertragl.</TableCell>
                    <TableCell width="45%" align='right'>Differenz</TableCell>
                    <TableCell width="45%" align='right'>Rechnungen</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!isEmpty(projectData) &&
                    projectData.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell width="45%">{data.name}</TableCell>
                        {this.tableFields(data, isInactive)}
                        <TableCell align="center">
                          <NumberFormat
                            customInput={TextField}
                            className="rightToLeft"
                            inputProps={{
                              maxLength: 40
                            }}
                            variant="outlined"
                            value={data.yearDaySum}
                            fixedDecimalScale={true}
                            thousandSeparator='.'
                            decimalSeparator=","
                            decimalScale='2'
                            disabled
                          />
                        </TableCell>
                        <TableCell align="center">
                          <NumberFormat
                            customInput={TextField}
                            className="rightToLeft"
                            inputProps={{
                              maxLength: 40
                            }}
                            variant="outlined"
                            value={data.vertragl}
                            thousandSeparator='.'
                            decimalSeparator=","
                            fixedDecimalScale={true}
                            decimalScale='2'
                            disabled
                          />
                        </TableCell>
                        <TableCell align="center">
                          <NumberFormat
                            customInput={TextField}
                            className="rightToLeft"
                            inputProps={{
                              maxLength: 40
                            }}
                            variant="outlined"
                            value={data.differenz}
                            thousandSeparator='.'
                            decimalSeparator=","
                            fixedDecimalScale={true}
                            decimalScale='2'
                            disabled
                          />
                        </TableCell>
                        <TableCell align="center">
                          <NumberFormat
                            customInput={TextField}
                            className="rightToLeft"
                            inputProps={{
                              maxLength: 40
                            }}
                            variant="outlined"
                            value={data.rechnungen}
                            thousandSeparator='.'
                            decimalSeparator=","
                            fixedDecimalScale={true}
                            decimalScale='2'
                            disabled
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  }
                  <TableRow align="center">
                    <TableCell width="45%">Summe</TableCell>
                    {totalYearSum.map((item, index) => (
                      <TableCell key={index} align="center">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft"
                          inputProps={{
                            maxLength: 40
                          }}
                          variant="outlined"
                          value={Number(item.daysum.toFixed(2))}
                          thousandSeparator='.'
                          decimalSeparator=","
                          fixedDecimalScale={true}
                          decimalScale='2'
                          disabled
                        />
                      </TableCell>
                    ))}
                    <TableCell align="center">
                      <NumberFormat
                        customInput={TextField}
                        className="rightToLeft"
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        value={Number(totalSummePlan)}
                        thousandSeparator='.'
                        decimalSeparator=","
                        fixedDecimalScale={true}
                        decimalScale='2'
                        disabled
                      />
                    </TableCell>
                    <TableCell align="center">
                      <NumberFormat
                        customInput={TextField}
                        className="rightToLeft"
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        value={Number(totalvertragel)}
                        thousandSeparator='.'
                        decimalSeparator=","
                        fixedDecimalScale={true}
                        decimalScale='2'
                        disabled
                      />
                    </TableCell>
                    <TableCell align="center">
                      <NumberFormat
                        customInput={TextField}
                        className="rightToLeft"
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        value={Number(totalDifferenz)}
                        thousandSeparator='.'
                        decimalSeparator=","
                        fixedDecimalScale={true}
                        decimalScale='2'
                        disabled
                      />
                    </TableCell>
                    <TableCell align="center">
                      <NumberFormat
                        customInput={TextField}
                        className="rightToLeft"
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        value={Number(totalRechnungen)}
                        thousandSeparator='.'
                        decimalSeparator=","
                        fixedDecimalScale={true}
                        decimalScale='2'
                        disabled
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </div>
        {!isEmpty(dataObj.comparedValText) && <span style={{ color: dataObj.color, float: "right", marginTop: "10px" }}>{dataObj.comparedValText}</span>}
        <Grid container spacing={1} justify="justify">
          <Grid item xs={12}>
            {!((Number(access_rights.projects_capacity_for_other) !== 2 && forOther) || (Number(access_rights.projects_capacity_for_own) !== 2 && forOwn)) &&
              <div className="inlinefield">
                <NumberFormat
                  customInput={TextField}
                  className="rightToLeft"
                  inputProps={{
                    maxLength: 4
                  }}
                  variant="outlined"
                  value={newYear}
                  fixedDecimalScale={true}
                  decimalSeparator=","
                  decimalScale={false}
                  allowNegative={false}
                  disabled={isInactive}
                  onChange={(e) => {
                    this.setState({ newYear: e.target.value, addYearError: false })
                  }}
                />
                <Button variant="outlined" color="primary" disabled={isInactive} onClick={() => {
                  if (!isEmpty(newYear) && changes) {
                    this.setState({ saveChangesDialog: true })
                  } else if (!isEmpty(newYear)) {
                    AddYear(projectId, newYear)
                  }
                }}>Jahr hinzufügen</Button>
              </div>
            }
          </Grid>
        </Grid>
        <Dialog
          open={saveChangesDialog}
        >
          <DialogTitle> Änderungen speichern</DialogTitle>
          <DialogContent>
            <DialogContentText >
              Möchtest du deine Änderungen speichern?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              UpdateCapacityPlannings(dataObj)
              AddYear(projectId, newYear)
              this.setState({ changes: false, saveChangesDialog: false })
            }} size="small" variant="outlined" color="primary" autoFocus>
              Bestätigen
              </Button>
            <Button onClick={() => this.setState({ saveChangesDialog: false })} size="small" variant="outlined" color="secondary">
              Abbrechen
              </Button>
          </DialogActions>
        </Dialog>
      </ div>
    )
  }
}

const mapStateToProps = ({ projectsData }) => {
  return {
    year_list: projectsData.year_list,
    compare_list: projectsData.compare_list
  }
}

const mapDispatchToProps = dispatch => {
  return {
    AddYear: (id, year) => dispatch(AddYear(id, year)),
    UpdateCapacityPlannings: (data) => dispatch(UpdateCapacityPlannings(data)),
    CompareCapacityWithPlan: (id) => dispatch(CompareCapacityWithPlan(id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CapacityPlanning)
